<template>
  <section class="portfolio">
    <div class="page-header">
      <h3 class="page-title" style="color:#696969 !important;">
        {{ contentType.label }} Categories
      </h3>

      <div class="btn-group">
        <!-- <RouterLink v-if="this.contentType.label == 'Meditation'" 
      class="btn btn-primary"
      to="/meditation-backgrounds/list"><i class="mdi mdi-settings"></i> Manage Backgrounds
        </RouterLink> -->
        <!-- search & pagination work -->
        <b-form-input type="text" class="searchInput" @keypress="handleKeyPress" placeholder="Search Categories"
          v-model="keyword"></b-form-input>
        <b-button @click="getResults()" class="btn btn-primary"><i class="fa fa-search"></i>
        </b-button>
        <b-button @click="clearSearchInput()" class="mr-4 btn btn-danger"><i class="fa fa-trash-o"></i>
        </b-button>
        <!-- // search & pagination work -->
        <b-button @click="showAddModal()" class="btn btn-success btn-fw"><i class="fa fa-plus"></i> Add Category
        </b-button>


      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="items.length > 0">
            <div class="row">
              <div class="col-12">
                <div class="row portfolio-grid">
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12" v-for="item in items" :key="item.id">
                    <figure class="effect-text-in" style="height: 300px;">
                      <span v-for="field in contentType.fields" :key="`${field.name}-${item.id}`">
                        <!-- <h4>{{ item[field.name] }}</h4> -->
                        <img v-if="field.tag == 'img'" :src="item[field.name]" alt="image" />
                      </span>
                      <figcaption>
                        <div v-for="(field, index) in contentType.fields" :key="`${field.name}-${item.id}`">

                          <!-- <div class="template-demo">
                            <button v-if="index == 0" @click="showEditModal(item.id,item.name,item.image)" type="button"
                              class="btn btn-social-icon btn-outline-facebook"><i
                                class="mdi mdi-lead-pencil"></i></button>
                            <button v-on:click="showAlert(item.id)" v-if="index == 0" type="button"
                              class="btn btn-social-icon btn-outline-youtube"><i
                                class="mdi mdi-delete-forever"></i></button>
                            <RouterLink v-if="index == 0" class="btn btn-social-icon btn-outline-youtube"
                              :to="`/${contentType.label2}/list/${item.id}`"><i class="mdi mdi-eye"></i>
                            </RouterLink> -->
                          <!-- <button v-on:click="showAlert(item.id)" v-if="index == 0" type="button"
                              class="btn btn-social-icon btn-outline-youtube"><i
                                class="mdi mdi-delete-forever"></i></button> -->
                          <!-- </div> -->

                          <span v-if="field.tag == 'h4'">
                            <h4>{{ item[field.name] }}</h4>
                          </span>
                          <!-- <span v-if="field.tag == 'p'">
                            <p>{{ item[field.name] }}</p>
                          </span> -->
                          <div class="btn-group button-group" role="group" aria-label="Basic example"
                            style="flex-wrap: wrap; position: absolute; bottom: 10px; left: 0; padding: 10px; margin-bottom: 0; width: 100%;">

                            <!-- <RouterLink v-if="index == 0" class="btn btn-sm btn-info"
                              :to="`/${contentType.label2}/list/${item.name}/${item.id}`"><i class="mdi mdi-eye"></i>
                            </RouterLink> -->

                            <a @click="showShowModal(item.name, item.id)" v-if="index == 0" class="btn btn-sm btn-info"><i
                                class="mdi mdi-eye"></i></a>

                            <a @click="showEditModal(item.id, item.name, item.image)" v-if="index == 0"
                              class="btn btn-sm btn-warning"><i class="mdi mdi-lead-pencil"></i></a>

                            <a v-on:click="showAlert(item.id)" v-if="index == 0" class="btn btn-sm btn-danger"><i
                                class="mdi mdi-delete-forever"></i></a>

                          </div>
                        </div>
                      </figcaption>
                    </figure>
                    <div class="effect-text-in-footer">
                      <div class="row">
                        <div class="col-md-7">
                          <span v-if="field.tag == 'h4'" v-for="field in contentType.fields"
                            :key="`${field.name}-${item.id}`">
                            <h6 style="color:#696969 !important; text-align: left; margin-left:20px;"
                              v-b-tooltip.html.bottom :title=item[field.name]>{{
                                item[field.name]
                              }}</h6>
                          </span>
                        </div>
                        <div class="col-md-4 pl-0 text-right">
                          <toggle-button @change="changeStatus(item)" :value="(item.status == 'Active') ? true : false" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <b-modal ref="edit-modal" id="modalmd" title="Edit Audio Category" size="md" hide-footer>
                    <AudioCategoryEditModal />
                  </b-modal>
                  <b-modal ref="add-modal" id="modalmd" title="Add Audio Category" size="md" hide-footer>
                    <AudioCategoryAddModal />
                  </b-modal> -->
                </div>
              </div>
            </div>
          </div>
          <div class="card-body" v-else>
            <h1>No Record Found</h1>
          </div>
        </div>
      </div>
    </div>
    <vue-snotify></vue-snotify>
  </section>
</template>

<script>
import AudioCategoryEditModal from "../modals/audio-category-modals/AudioCategoryEditModal.vue";
import AudioCategoryAddModal from "../modals/audio-category-modals/AudioCategoryAddModal.vue";
import api from "../../config/api.js";
export default {
  name: "ListingContainer",
  components: {
    AudioCategoryEditModal,
    AudioCategoryAddModal,
  },

  props: {
    contentType: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      // search & pagination work
      baseUrl: "", // search & pagination work
      searchedUrl: "", // search & pagination work
      keywordEmptyAfterDelete: false,
      searchButtonClicked: false,
      keyword: "",
      items_data: "",
      // search & pagination work
    }
  },
  // search & pagination work

  watch: {
    keyword(after, before) {
      if (after != "") this.searchButtonClicked = false;
      // this.getResults();
    }
    // search & pagination work

    //     keyword(after, before) {
    //   if (after != "") {
    //     if(this.items.length > 0){
    //       this.empty_data_error = "";
    //     }
    //   } else if(after == "" && !this.keywordEmptyAfterDelete) {
    //     this.searchButtonClicked = false;
    //     this.getData();
    //   }
    // },


  },

  computed: {
    items: {
      get() {
        if (this.keyword != "" && this.searchButtonClicked) {
          return this.items_data;
        } else {
          return this.$store.getters[`${this.contentType.name}/list`];
        }
      },
      set(value) {
        this.items_data = value;
      }
    }
  },
  async created() {
    this.$root.$refs.Category = this;
    await this.$store.dispatch(`${this.contentType.name}/all`);
    if (this.$store.getters['getMessage']) {
      let obj = this.$store.getters['getMessage'];
      this.$swal('Success!', obj.msg, 'success')
      // this.showSnotifySuccess(obj.msg)
      this.$store.dispatch('setMessage', "");
    }
  },

  mounted() {
    //   document.getElementById('searchBtn').addEventListener("keypress", function (e) {
    //     if (e.code == "Enter") {
    //       if(this.keyword != ""){
    //         this.getResults()
    //       }
    //     }
    //   }.bind(this));
    const module_name = this.contentType.name;
    if (module_name) {
      if (module_name == "hypnosis-categories") {
        this.baseUrl = "admin/hypno-cat-audios?hypno_cat_id"
        this.searchedUrl = "/admin/livesearch-hypno-cat"
      } else if (module_name == "meditation-categories") {
        this.baseUrl = "admin/meditation-cat-audios?meditation_cat_id"
        this.searchedUrl = "/admin/livesearch-med-cat"
      } else if (module_name == "affirmation-categories") {
        this.baseUrl = "admin/affirmation-cat-audios?affirmation_cat_id"
        this.searchedUrl = "/admin/livesearch-aff-cat"
      }
    }
  },

  methods: {
    // search & pagination work
    handleKeyPress(event) {
      if (event.key == "Enter" && this.keyword != "") {
        this.getResults()
      }
    },

    clearSearchInput() {
      this.keyword = "";
      this.keywordEmptyAfterDelete = false;
    },

    getResults() {
      this.searchButtonClicked = true;
      if (this.keyword != "") {
        api.get(this.searchedUrl, { params: { keyword: this.keyword } })
          .then(res => this.items = res.data)
          .catch(error => console.log("getResults : ", error));

        console.log(this.items);
      }
    },
    // search & pagination work

    async changeStatus(item) {
      item.status = !item.status
      let endpoint = "";
      if (this.contentType?.name != "") {
        if (this.contentType.name == "hypnosis-categories") {
          endpoint = `/admin/hypno-cat-status?id=${item.id}`;
        }
        else if (this.contentType.name == "meditation-categories") {
          endpoint = `/admin/med-cat-status?id=${item.id}`;
        }
        else if (this.contentType.name == "affirmation-categories") {
          endpoint = `/admin/aff-cat-status?id=${item.id}`;
        }
      }
      try {
        let result = await api.post(endpoint);
        await this.$store.dispatch(`${this.contentType.name}/all`);
        this.$swal('Success!', result.data.message, 'success')
        // search & pagination work
        if (this.keyword != "") {
          this.getResults()
        }
        // search & pagination work
      } catch (error) {
        this.error = error.response.data.message;
        this.$toast.error(this.error);
      }
    },

    // ${contentType.label2}/list/${item.name}/${item.id}

    async showShowModal(name, id) {
      let url = `/${this.contentType.label2}/list/${id}`;
      await this.$store.dispatch('setHeaderData', { "category_name": name })
      var obj = { "category_name": name };
      localStorage.setItem('data_for_header', JSON.stringify(obj));
      this.$router.push({ path: url });
    },


    async showEditModal(id, name, image) {
      await this.$store.dispatch('setDataInEditForm', { "type": this.contentType.name, id, name, image })
      var obj = {
        "type": this.contentType.name,
        "id": id,
        "name": name,
        "image": image
      };
      localStorage.setItem('data_for_edit', JSON.stringify(obj));
      // this.$refs['edit-modal'].show()
      const url = `/${this.contentType.name}/${id}/edit`
      console.log(url);
      this.$router.push({ path: url });
    },

    // async showAddModal() {
    //   await this.$store.dispatch('setDataInEditForm', { "type": this.contentType.name })
    //   this.$refs['add-modal'].show()
    // },

    async showAddModal() {
      await this.$store.dispatch('setDataInEditForm',
        { "type": this.contentType.name })
      // localStorage.setItem('obj',{ "type": this.contentType.name, "category_id": this.category_id })
      // this.$refs["add-modal"].show();
      const url = `/${this.contentType.name}/add/`
      console.log(url);
      this.$router.push({ path: url });
    },

    showSnotifySuccess(msg) {
      let obj = this.$store.getters['getMessage'];
      this.$snotify.success(obj.msg, {
        timeout: 5000,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });
    },
    showSnotifyError(msg) {
      let obj = this.$store.getters['getMessage'];
      this.$snotify.error(obj.msg, {
        timeout: 5000,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });
    },

    showAlert(id) {
      try {
        let endpoint2 = "";
        const module_name = this.contentType.name;
        if (module_name) {
          if (module_name == "hypnosis-categories") {
            endpoint2 = "/admin/delete-hypnosis-cat/";
          }
          else if (module_name == "meditation-categories") {
            endpoint2 = "/admin/delete-meditation-cat/";
          }
          else if (module_name == "affirmation-categories") {
            endpoint2 = "/admin/delete-affirmation-cat/";
          }
        }
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then(async (res) => {
          if (res.value) {
            let result = await api.delete(endpoint2 + id);
            result = await this.$store.dispatch(`${this.contentType.name}/all`);
            this.$swal(
              'Deleted!',
              'Category has been deleted.',
              'success'
              // search & pagination work
            ).then(() => {
              this.keyword = "";
              this.keywordEmptyAfterDelete = true;
            })
            // search & pagination work
          }
        })
      } catch (error) {
        let err = error.response.data.message;
        this.$store.dispatch('setMessage', { err });
        this.showSnotifyError()
      }
    }
  }
};
</script>

<style>
table {
  width: 100%;
  border-collapse: collapse;
}

thead th {
  text-align: left;
}

tbody tr {
  cursor: pointer;
  transition: background-color 0.2s;
}

tbody tr:nth-child(odd) {
  background-color: #f9f9f9;
}

tbody tr:hover {
  background-color: #efefef;
}

td,
th {
  padding: 0.25em;
}

.effect-text-in-footer {
  margin-bottom: 30px;
  padding-bottom: 10px;
  text-align: center;
  box-shadow: -2px 8px 20px 2px #0000002b;
}

.portfolio-grid .effect-text-in img {
  z-index: 100;
  opacity: 1;
  height: 50px;
  object-fit: cover;
}

.portfolio-grid figure {
  background: #fff !important;
}

.portfolio-grid .btn-outline-secondary:hover,
.portfolio-grid .btn-outline-secondary:focus,
.portfolio-grid .btn-outline-secondary:active {
  border-color: #3bccb0 !important;
  background: #3bccb0 !important;
  color: #ffffff;
}

.portfolio-grid .btn-outline-secondary,
.portfolio-grid .btn-outline-secondary,
.portfolio-grid .btn-outline-secondary {
  border-color: #3bccb0;
  color: #3bccb0;
}
</style>
